import React from 'react';
import { Box } from '@fiverr-private/theme';
import type { SystemIconType } from '@fiverr-private/visuals';

interface ResponsiveIconProps {
  Icon: React.ComponentType<SystemIconType>;
}

/**
 * Renders a Penta system icon at `xs` (12px) below the `sm` breakpoint and
 * `sm` (16px) from `sm` up. System icons accept only a string `size`, so
 * responsiveness is achieved by toggling two instances via `display`.
 */
export const ResponsiveIcon: React.FC<ResponsiveIconProps> = ({ Icon }) => (
  <>
    <Box display={{ default: 'flex', sm: 'none' }} alignItems="center">
      <Icon size="xs" />
    </Box>
    <Box display={{ default: 'none', sm: 'flex' }} alignItems="center">
      <Icon size="sm" />
    </Box>
  </>
);
